export default __webpack_public_path__ + "static/media/intro4.49af8e0c.mp3";